import React, { Component, createContext } from "react";
import Api from "../Api";

export const formRefContext = createContext();

class Form extends Component {
  constructor(props) {
    super(props);

    this.setLinkedFields = this.setLinkedFields.bind(this);
    this.state = {
      linkedFields: [],
      setLinkedFields: this.setLinkedFields,
    };
    this.formRef = React.createRef();

    this.preSubmit = this.preSubmit.bind(this);
    this.submit = this.submit.bind(this);
    this.createLinkField = this.createLinkField.bind(this);
  }

  async createLinkField(defDossier, datas) {
    try {
      const { id } = await Api.dossiers.Create({
        defDossier,
        ...datas,
      }, this.props.apiUsername, this.props.apiKey);
      return id;
    } catch (error) {
      throw error;
    }
  }

  async preSubmit(data) {
    if (this.state.linkedFields.length > 0 && !this.props.skipLinkedContainers) {
      for (let i = 0; i < this.state.linkedFields.length; i++) {
        let nDatas = {};
        if (typeof data === "object" && data !== null) {
          for (const key in data) {
            if (key.startsWith(this.state.linkedFields[i].displayItem)) {
              let fieldId = key.split("_")[1];
              if (fieldId) {
                nDatas[fieldId] = data[key];
              }
            }
          }
        }
        this.props.register(this.state.linkedFields[i].displayItem);
        const dosierId = await this.createLinkField(
          this.state.linkedFields[i].defdossier,
          nDatas
        );
        this.props.setValue(
          this.state.linkedFields[i].displayItem,
          dosierId.toString()
        );
      }
    }

    this.props.handleSubmit(this.submit)(data);
  }

  submit(data) {
    if (!this.props.skipLinkedContainers) {
      for (const key in data) {
        let fieldId = key.split("_");
        if (fieldId.length > 1) {
          this.props.unregister(key);
          delete data[key];
        }
      }
    }

    if (this.props?.onSubmit) {
      this.props.onSubmit(data);
    }
  }

  setLinkedFields(linkedFields) {
    this.setState({ linkedFields });
  }

  render() {
    return (
      <formRefContext.Provider value={this.state}>
        <form
          ref={this.formRef}
          className={this.props?.className ?? ""}
          onSubmit={this.props.handleSubmit(this.preSubmit)}
        >
          {this.props?.children && this.props.children.length > 1
            ? this.props.children.map((children) => {
              return <>{children}</>;
            })
            : this.props.children}
        </form>
      </formRefContext.Provider>
    );
  }
}

export default Form;
